import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  VStack,
  useDisclosure,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { FaChartLine, FaUserCircle } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { AiOutlineHistory } from "react-icons/ai";
import { BsFillCreditCardFill, BsLightningChargeFill, BsCurrencyBitcoin } from "react-icons/bs";
import { MdBlock, MdOutlineLocalOffer } from "react-icons/md";
import { SlGraph } from "react-icons/sl";
import { AppContext } from "../../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { RiMessage2Fill } from "react-icons/ri";

const ButtonsList = [
  {
    title: "Users",
    icon: <FaUserCircle style={{ fontSize: "1.5rem" }} />,
    link: "/admin/users",
  },
  // {
  //   title: "Recharge",
  //   icon: <BsLightningChargeFill style={{ fontSize: "1.5rem" }} />,
  //   link: "/admin/recharge",

  // },
  {
    title: "Daily Stats",
    icon: <SlGraph style={{ fontSize: "1.5rem" }} />,
    link: "/admin/daily",
  },
  {
    title: "Currency",
    icon: <BsCurrencyBitcoin style={{ fontSize: "1.5rem" }} />,
    link: "/admin/currency",
  },
  {
    title: "Services",
    icon: <BsFillCreditCardFill style={{ fontSize: "1.5rem" }} />,
    link: "/admin/services",
  },
  {
    title: "Transactions",
    icon: <AiOutlineHistory style={{ fontSize: "1.5rem" }} />,
    link: "/admin/transaction",
  },
  {
    title: "Otp history",
    icon: <RiMessage2Fill style={{ fontSize: "1.5rem" }} />,
    link: "/admin/otp-history",
  },
  {
    title: "Coupon",
    icon: <MdOutlineLocalOffer style={{ fontSize: "1.5rem" }} />,
    link: "/admin/coupon",
  },
  { title: "Logout", icon: <FiLogOut style={{ fontSize: "1.5rem" }} /> },
];
const AdminLeftSideBar = ({ onClose: closeDrawer }) => {
  const [active, setActive] = useState("");
  const { isDark, setIsAdmin } = useContext(AppContext);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const navigate = useNavigate();

  // Dark theme colors
  const activeBg = "whiteAlpha.200";
  const inactiveColor = "gray.400";
  const hoverBg = "whiteAlpha.200";

  useEffect(() => {

  }, [])
  const handleLogout = () => {
    onClose();
    localStorage.removeItem("Token");
    setIsAdmin(false);
    toast({
      status: "success",
      title: "Successfully logout",
      isClosable: true,
      duration: 2000,
    });
  };
  return (
    <VStack w={"100%"} h="full" bg="gray.900" borderRight="1px" borderColor="gray.700">
      <VStack w={"100%"} gap={"1rem"} pt={"1rem"} align={"center"}>
        {ButtonsList.map((el) => (
          <Button
            key={el.title}
            outline={"none !important"}
            onClick={() => {
              setActive(el.title);
              if ("Logout" == el.title) {
                onOpen();
              } else {
                navigate(el.link);
                if (closeDrawer) closeDrawer();
              }
            }}
            bg={active === el.title ? activeBg : "transparent"}
            color={
              active === el.title
                ? "brand.500"
                : inactiveColor
            }
            _hover={{
              bg: hoverBg,
              color: "brand.600",
            }}
            gap={"0.6rem"}
            fontWeight={400}
            fontSize={"1.15rem"}
            p={"1.4rem 0.6rem"}
            w={"95%"}
            justifyContent={"start"}
            leftIcon={el.icon}
            variant="ghost"
          >
            {el.title}
          </Button>
        ))}
      </VStack>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent bg="gray.800" color="white">
          <ModalCloseButton />
          <ModalBody
            display={"flex"}
            justifyContent={"center"}
            minH={"30vh"}
            gap={"1rem"}
            alignItems={"center"}
            pb={6}
          >
            <Button
              onClick={handleLogout}
              _hover={{
                bg: "gray.700",
                color: "brand.500",
                borderColor: "brand.500",
              }}
              color={"white"}
              bg={"brand.500"}
              border={"2px solid"}
              borderColor={"brand.500"}
            >
              Logout
            </Button>
            <Button
              onClick={onClose}
              color={"brand.500"}
              bg={"gray.800"}
              border={"2px solid"}
              borderColor={"brand.500"}
              _hover={{
                bg: "brand.500",
                color: "white",
              }}
            >
              Cancel
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </VStack>
  );
};

export default AdminLeftSideBar;
